/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Email_TitleInputs */

const en_common_sign_email_title = /** @type {(inputs: Common_Sign_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const zh_common_sign_email_title = /** @type {(inputs: Common_Sign_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Common_Sign_Email_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_email_title = /** @type {((inputs?: Common_Sign_Email_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Email_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_email_title(inputs)
	return zh_common_sign_email_title(inputs)
});
export { common_sign_email_title as "common.sign.email_title" }